import clsx from 'clsx';
import React, { ReactNode, ReactElement } from 'react';
import { theme } from '../tailwind.config';

interface HexagonProps {
  size: number;
  hexagonColor: string;
  childrenColor?: string;
  children?: ReactNode;
  className?: string;
}

const Hexagon = ({
  size,
  hexagonColor,
  childrenColor = theme.colors.white,
  children,
  className,
}: HexagonProps): ReactElement => (
  <>
    <style jsx>
      {`
        .hexagon {
          text-align: left;
          position: relative;
          width: ${size}px;
          height: ${(size * 57.74) / 100}px;
          background-color: ${hexagonColor};
          margin: ${(size * 28.87) / 100}px 0;
          z-index: 1;
        }

        .children {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: 2;
          color: ${childrenColor};
          font-size: 12px;
          line-height: 22px;
        }

        .hexagon:before,
        .hexagon:after {
          content: '';
          position: absolute;
          width: 0;
          border-left: ${size / 2}px solid transparent;
          border-right: ${size / 2}px solid transparent;
        }

        .hexagon:before {
          position: absolute;
          bottom: 100%;
          border-bottom: ${(size * 28.87) / 100}px solid ${hexagonColor};
        }

        .hexagon:after {
          top: 100%;
          width: 0;
          border-top: ${(size * 28.87) / 100}px solid ${hexagonColor};
        }
      `}
    </style>
    {children && <span className="children">{children}</span>}
    <div className={clsx('hexagon', className)} />
  </>
);

export default Hexagon;
